import styled from 'styled-components';

export const SectionWrap = styled.section`
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 40px;
  letter-spacing: 2px;
`;
